import React, { Component, HTMLAttributes } from "react";
import classnames from "classnames";

import * as styles from "./Table.scss";

export interface ITableProps {
    disableScrolling?: boolean;
}

export class Table extends Component<
    ITableProps & HTMLAttributes<HTMLElement>
> {
    public container?: HTMLElement;

    public render() {
        const { className, disableScrolling, children, ...props } = this.props;

        return (
            <div
                className={classnames(
                    styles.table,
                    className,
                    disableScrolling && styles["disable-scrolling"],
                )}
                {...props}
            >
                <div
                    className={styles.container}
                    ref={_ => (this.container = _ || undefined)}
                >
                    <table>{children}</table>
                </div>
            </div>
        );
    }
}
